import { Link } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// import logo from "../assets/Logo-white.png";
import plus from "../assets/18plus.png"

export default function Footer(){
    return(
    <footer>
        <Container>
            <Row>
                <Col className="text-center py-5">
                {/* <Link to="/"><img src={logo} alt="Logo" /></Link> */}
                </Col>
            </Row>
        </Container>

        {/* New Contact Information Section */}
        <Container className="contact-info-section py-5">
            <Row>
                <Col md={4} className="contact-item">
                    <div className="contact-icon">
                        <i className="fas fa-phone" style={{ color: '#B4975A' }}></i>
                    </div>
                    <div className="contact-content">
                        <h4 className="contact-title">Telefoon</h4>
                        <p className="contact-text">+47 22 83 70 10</p>
                    </div>
                </Col>
                <Col md={4} className="contact-item">
                    <div className="contact-icon">
                        <i className="fas fa-envelope" style={{ color: '#B4975A' }}></i>
                    </div>
                    <div className="contact-content">
                        <h4 className="contact-title">E-mail</h4>
                        <p className="contact-text">meister@gmail.com</p>
                    </div>
                </Col>
                <Col md={4} className="contact-item">
                    <div className="contact-icon">
                        <i className="fas fa-map-marker-alt" style={{ color: '#B4975A' }}></i>
                    </div>
                    <div className="contact-content">
                        <h4 className="contact-title">Adres</h4>
                        <p className="contact-text">Dronning Eufemiasgate 16,<br /> 0191 Oslo, Noorwegen</p>
                    </div>
                </Col>
            </Row>
        </Container>

        <Container className="footerTop py-4">
            <Row>
                <Col xs={12} md={6} className="mb-3 mb-md-0">
                    <h3 className="h3Heading text-yellow">Zorgt ervoor dat iedereen verantwoord speelt</h3>
                    <p className="footerSub">Lees meer op onze speciale pagina over Verantwoord Sociaal Spel.</p>
                </Col>
                <Col xs={10} md={5} className="mb-3 mb-md-0">
                    <p className="highlight mobile-full-width">
                        <Link to="/ansvarlig-sosialt-spill">GA NAAR VERANTWOORD SOCIAAL SPEL</Link>
                    </p>
                </Col>
                <Col xs={2} md={1} className="text-right">
                    <img src={plus} alt="18+" className="age-restriction" />
                </Col>
            </Row>
        </Container>
        
        <Container className="footerMiddle pb-4">
            <Row>
                <Col xs={12} md={9} className="mb-4 mb-md-0">
                    <div className="disclaimer-text">
                        <p>Dit is een gratis sociaal casino gericht op entertainment.</p>
                        <p>Er is geen echt geld betrokken en er kunnen geen geldprijzen worden gewonnen.</p>
                        
                        <p className="disclaimer-heading">Disclaimer:</p>
                        <p>Deze website is uitsluitend ontwikkeld voor gratis entertainment.</p>
                        <p>Alle spellen op deze site zijn in eigen beheer ontwikkeld en enkel bedoeld voor amusementsdoeleinden.</p>
                        <p>De spellen zijn bedoeld voor volwassenen van 18 jaar en ouder.</p>
                        <p>Onze sociale casinospellen bevatten geen echt geld en bieden geen mogelijkheid om prijzen of geldprijzen te winnen.</p>
                        <p>Vooruitgang in de spellen is geen indicatie van vaardigheid in gokken met echt geld.</p>
                        
                        <p className="disclaimer-footer">Wij moedigen verantwoord spelen aan en benadrukken dat de spellen op Firgoquast uitsluitend bedoeld zijn als amusement.</p>
                    </div>
                </Col>
                
                <Col xs={12} md={3} className="footer-links-col">
                    <ul className="footer-links">
                        <Link to="/tjenestevilkår"><li>Gebruiksvoorwaarden</li></Link>
                        <Link to="/ansvarlig-sosialt-spill"><li>Verantwoord Sociaal Spel</li></Link>
                        <Link to="/personvernregler"><li>Privacybeleid</li></Link>
                        <Link to="/kontakt-oss"><li>Contact</li></Link>
                        <Link to="/ansvarsfraskrivelse"><li>Disclaimer</li></Link>
                        <Link to="/om-oss"><li>Over ons</li></Link>
                    </ul>
                </Col>
            </Row>
        </Container>
        
        <Container className="footerBottom py-3">
            <Row>
                <Col className="text-center">
                    <p className="copyright">© 2025 Firgoquast AS – Alleen voor entertainment. Geen kansspelen. Geen echt geld. Geen geldprijzen.</p>
                </Col>
            </Row>
        </Container>
    </footer>
)

}